<ng-container [ngSwitch]="element.type">

  <!-- Body composition pie chart -->
  <ng-container *ngSwitchCase="'body-composition'">
    <div *ngIf="testLoaded; else placeholderText">
      <div id="body_composition-{{ uniquePageKey }}-{{ element.slug }}"></div>
    </div>
  </ng-container>

  <!-- Metabolic fingerprint radar chart -->
  <ng-container *ngSwitchCase="'metabolic-fingerprint'">
    <div *ngIf="testLoaded; else placeholderText">
      <div id="metabolic_fingerprint-{{ uniquePageKey }}-{{ element.slug }}">
        <div class="water-mark"></div>
        <canvas id="metabolic_fingerprint-{{ uniquePageKey }}-{{ element.slug }}_radar"></canvas>
      </div>
    </div>
  </ng-container>

  <!-- Metabolic capacities grid charts -->
  <ng-container *ngSwitchCase="'metabolic-capacities-grid'">
    <div class="overlay-wrapper">
      <div class="overlay-content-wrapper">
        <div *ngIf="element.heading != null"
            [style.color]="getTextHeadingColor()"
            [innerHTML]="getSafeHtml(getTextHeading())"
            class="text-heading"></div>

        <div *ngIf="testLoaded; else placeholderText" class="capacities-grid-container">
          <div *ngFor="let item of gaugeChartData" [class]="'capacities-grid-item ' + (isLandscape ? 'landscape' : 'portrait')">
            <div class="item-title">{{ extractTextFromHtml(item.title) }} </div>
            <canvas id="gauge-{{ item.key }}" style="width:100%"></canvas>
            <div *ngIf="item.value !== 'no_label'" class="c-chart-gauge__value item-value">
              <span *ngIf="item.prefix" [innerHTML]="item.prefix"></span>&nbsp;
              <strong class="u-margin-right-xxs">{{ item.value }}</strong>
              <span>{{ item.unit }}</span>
            </div>
            <div *ngIf="item.value_alternative_1 !== 'no_label'" class="item-value-alternative">
              <span *ngIf="item.prefix_alternative_1" [innerHTML]="item.prefix_alternative_1"></span>&nbsp;
              <strong class="u-margin-right-xxs">{{ item.value_alternative_1 }}</strong>
              <span>{{ item.unit_alternative_1 }}</span>
            </div>
            <div *ngIf="item.value_alternative_2 !== 'no_label'" class="item-value-alternative">
              <span *ngIf="item.prefix_alternative_2" [innerHTML]="item.prefix_alternative_2"></span>&nbsp;
              <strong class="u-margin-right-xxs">{{ item.value_alternative_2 }}</strong>
              <span>{{ item.unit_alternative_2 }}</span>
            </div>
            <div *ngIf="item.value_alternative_3 !== 'no_label'" class="item-value-alternative">
              <span *ngIf="item.prefix_alternative_3" [innerHTML]="item.prefix_alternative_3"></span>&nbsp;
              <strong class="u-margin-right-xxs">{{ item.value_alternative_3 }}</strong>
              <span>{{ item.unit_alternative_3 }}</span>
            </div>
          </div>
        </div>

        <div *ngIf="element.content != null"
            [innerHTML]="getSafeHtml(getTextContent())"
            class="text-content"></div> 
      </div>  

      <div class="edit-overlay">
        <button mat-icon-button class="overlay-edit-button" title="Edit page title" (click)="onEditText()">
          <mat-icon>edit</mat-icon>
        </button>
      </div>  
    </div>
  </ng-container>

  <!-- Metabolic capacity single chart -->
  <ng-container *ngSwitchCase="'metabolic-capacities-single'">
    <div *ngIf="testLoaded; else placeholderText" class="capacities-single-container">
      <div *ngFor="let item of gaugeChartData" class="capacities-grid-item-single">
        <div class="item-title">{{ extractTextFromHtml(item.title) }} </div>
        <canvas id="gauge-{{ item.key }}" style="width:100%"></canvas>
        <div *ngIf="item.value !== 'no_label'" class="c-chart-gauge__value item-value">
          <small *ngIf="item.prefix" [innerHTML]="item.prefix"></small>&nbsp;
          <strong class="u-margin-right-xxs">{{ item.value }}</strong>
          <small>{{ item.unit }}</small>
        </div>
        <div *ngIf="item.value_alternative_1 !== 'no_label'" class="item-value-alternative">
          <small *ngIf="item.prefix_alternative_1" [innerHTML]="item.prefix_alternative_1"></small>&nbsp;
          <strong class="u-margin-right-xxs">{{ item.value_alternative_1 }}</strong>
          <small>{{ item.unit_alternative_1 }}</small>
        </div>
        <div *ngIf="item.value_alternative_2 !== 'no_label'" class="item-value-alternative">
          <small *ngIf="item.prefix_alternative_2" [innerHTML]="item.prefix_alternative_2"></small>&nbsp;
          <strong class="u-margin-right-xxs">{{ item.value_alternative_2 }}</strong>
          <small>{{ item.unit_alternative_2 }}</small>
        </div>
        <div *ngIf="item.value_alternative_3 !== 'no_label'" class="item-value-alternative">
          <small *ngIf="item.prefix_alternative_3" [innerHTML]="item.prefix_alternative_3"></small>&nbsp;
          <strong class="u-margin-right-xxs">{{ item.value_alternative_3 }}</strong>
          <small>{{ item.unit_alternative_3 }}</small>
        </div>
      </div>
    </div>
  </ng-container>

  <ng-container *ngSwitchCase="'load-charcteristics'">
    <div *ngIf="testLoaded; else placeholderText">
      <div *ngIf="renderForPdf" id="metabolic_profile-{{ uniquePageKey }}-{{ element.slug }}-pdf"></div>
      <div id="metabolic_profile-{{ uniquePageKey }}-{{ element.slug }}"></div>
    </div>
  </ng-container>

  <ng-container *ngSwitchCase="'load-characteristics-single'">
    <div *ngIf="testLoaded; else placeholderText">
      <div *ngIf="renderForPdf" id="metabolic_profile-{{ uniquePageKey }}-{{ element.slug }}-pdf"></div>
      <div id="metabolic_profile-{{ uniquePageKey }}-{{ element.slug }}"></div>
    </div>
  </ng-container>

  <ng-container *ngSwitchCase="'ppd-cross-validation'">
    <div *ngIf="testLoaded; else placeholderText">
      <div *ngIf="renderForPdf" id="test_data-{{ uniquePageKey }}-{{ element.slug }}-pdf"></div>
      <div id="test_data-{{ uniquePageKey }}-{{ element.slug }}"></div>
    </div>
  </ng-container>

  <ng-container *ngSwitchCase="'metabolic-demand'">
    <div *ngIf="testLoaded; else loaderImage">
      <div *ngIf="renderForPdf" id="metabolic_demand-{{ uniquePageKey }}-{{ element.slug }}-pdf"></div>
      <div id="metabolic_demand-{{ uniquePageKey }}-{{ element.slug }}"></div>
    </div>
  </ng-container>

  <ng-container *ngSwitchCase="'lactate-accumulation'">
    <div *ngIf="testLoaded; else loaderImage">
      <div *ngIf="renderForPdf" id="lactate_accumulation-{{ uniquePageKey }}-{{ element.slug }}-pdf"></div>
      <div id="lactate_accumulation-{{ uniquePageKey }}-{{ element.slug }}"></div>
    </div>
  </ng-container>

  <ng-container *ngSwitchCase="'kinetics'">
    <div *ngIf="testLoaded; else loaderImage">
      <div *ngIf="kinecticsGraphType.value === 1">
        <app-kinetics-graph [config]="stepTestConfigGeneral.value"></app-kinetics-graph>
      </div>
      <div *ngIf="kinecticsGraphType.value === 2">
        <app-kinetics-graph-step-test [config]="stepTestConfigGeneral.value"></app-kinetics-graph-step-test>
      </div>
      <div *ngIf="kinecticsGraphType.value > 2">
        <app-multi-kinetics-graph-runs [elementSuffix]="elementSuffix" [config]="stepTestConfigGeneral.value"></app-multi-kinetics-graph-runs>
      </div>
    </div>
  </ng-container>

  <ng-container *ngSwitchCase="'performance-development'">
    <div class="overlay-wrapper">
      <div class="overlay-content-wrapper">
        <div *ngIf="element.heading != null"
            [style.color]="getTextHeadingColor()"
            [innerHTML]="getSafeHtml(getTextHeading())"
            class="text-heading"></div>

        <div *ngIf="testLoaded; else placeholderText">
          <div *ngIf="renderForPdf" id="performance_development_3-{{ uniquePageKey }}-{{ element.slug }}-pdf"></div>
          <div id="performance_development_3-{{ uniquePageKey }}-{{ element.slug }}"></div>
        </div>

        <br />
        <div *ngIf="element.content != null"
          [innerHTML]="getSafeHtml(getTextContent())"
          [style.font-size.%]="100 * getZoomLevel()"
          [style.line-height]="getZoomLevel() + 'rem'"
          class="text-content"></div> 
      </div>

      <div class="edit-overlay">
        <button mat-icon-button class="overlay-edit-button" title="Edit page title" (click)="onEditText()">
          <mat-icon>edit</mat-icon>
        </button>
      </div>  
    </div>
  </ng-container>

  <ng-template #placeholderText>
    <p>Loading your test data...</p>
  </ng-template>

  <ng-template #loaderImage>
    <div class="loader-image">
      <div class="loader-image__wrapper">
        <mat-spinner diameter="36" [style.--spinner-color]="'#33ee33'"></mat-spinner>
        <div class="loader-image__label">Loading graph...</div>
      </div>
    </div>
  </ng-template>

</ng-container>
